import moment from 'moment'
export function resetClaims() {
  return {
    type: 'RESET_CLAIMS',
  }
}

export function formatTime(time) {
  if (!time) return
  if (Array.isArray(time)) {
    var [h, m] = time.split(':')
    return (h % 12) + 12 * (h % 12 == 0) + ':' + m, h >= 12 ? 'PM' : 'AM'
  }

  return time
}

export function setDisclaimer(show) {
  return {
    type: 'SET_DISCLAIMER',
    payload: { show },
  }
}

export function getDateTimeDisplay(date, time) {
  return date && time
    ? moment(date).format('ddd, MMM D, YYYY') + ' at ' + moment(time).format('h:mm A')
    : null
}
